import { CrashReporter } from './CrashReporter'
import { SentryErrorReporter } from './SentryErrorReporter'

export const initializeCrashReporter = () => {
  CrashReporter.setReporter(new SentryErrorReporter())
}
